// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"a84e0eea","1632":"3ef41167","1871":"3c2910d0","2208":"3ef41167","5553":"3ef41167","5778":"3ef41167"}[chunkId] + ".chunk.css";
};